// Package imports:
import React from 'react';
// Component imports:
import LeigusamningarComp from '../../components/Leigusamningar/Leigusamningar';
import Entrypoint from '../Entrypoint';

const RentAgreement: React.FC = () => {
    return (
        <Entrypoint>
            <LeigusamningarComp />
        </Entrypoint>
    )
}

export default RentAgreement;